import { OlVectorLayer } from "@daniellang/schulwegeplan/components/ol/layers/ol-vector-layer";

import GeoJSON from "ol/format/GeoJSON";
import { Vector } from "ol/source";
import VectorSource from "ol/source/Vector";
import Style, { StyleFunction, StyleLike } from 'ol/style/Style';
import { FlatStyleLike } from "ol/style/flat";
import Feature, { FeatureLike } from "ol/Feature";
import { Cluster } from "ol/source";
import Icon from "ol/style/Icon";

import { customElement } from "lit/decorators.js";
import type { YellowFootFeature, YellowFootProperties } from "./feature-types";
import { hasPanorama } from "./feature-types";

import yellowFootsIconSvg from "../../assets/svg/foots.svg";

const geoJson = new GeoJSON({
    dataProjection: "EPSG:4326",
    featureProjection: "EPSG:3857",
});

@customElement("swp-yellow-foot")
export class SwpYellowFootLayer extends OlVectorLayer {

    protected isFeatureInteractive(feature: FeatureLike): boolean {
        return hasPanorama(feature);
    }

    protected createStyle(): StyleLike | FlatStyleLike | null | undefined {
        const deg2rad = (degrees: number) => degrees * Math.PI / 180;

        const styleFunction: StyleFunction = (feature: FeatureLike) => {
            const features = feature.get("features") as FeatureLike[] | undefined;

            if (!features) {
                return undefined;
            }

            features.sort((a, b) => {
                const priorityA = a.get("priority-rank") || 0;
                const priorityB = b.get("priority-rank") || 0;

                return priorityB - priorityA;
            });
            const singleYellowFoot = features[0];

            const desiredRotationInDegree = singleYellowFoot.get("rotation") || 0;
            const rotation = deg2rad(desiredRotationInDegree);

            const color = singleYellowFoot.get("color") || "#ffff00";

            const style = new Style({
                
                image: new Icon({
                    src: yellowFootsIconSvg,
                    color,
                    scale: 0.055,
                    rotation,
                    rotateWithView: true,
                }),
            });

            if (features.length === 1) {
                return style;
            } else if (features.length > 1) {
                return style;
            }
        };

        return styleFunction;
    }

    protected createSource(): Vector {
        const yellowFootsSource = new VectorSource();

        const clusteredYellowFootsSource = new Cluster({
            source: yellowFootsSource,
            distance: 20,
            createCluster: (point, features) => {
                const cluster = new Feature({
                    geometry: point,
                    features: features
                });

                return cluster;
            },
        });

        (async () => {
            const yellowFootsResponse = await fetch("./assets/geojson/yellow-foot.geojson");
            const yellowFootsData = await yellowFootsResponse.json();
            const yellowFoots = geoJson.readFeatures(yellowFootsData) as YellowFootFeature[];

            yellowFootsSource.addFeatures(yellowFoots);
        })();
        
        return clusteredYellowFootsSource;
    }

}
